import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import telegramAnalytics from '@telegram-apps/analytics';
import { App } from './App';
import './index.css';

// Intentionally no @telegram-apps/telegram-ui AppRoot wrapper — its
// `.tgui` class overrode our text colour via CSS variables and produced
// dark-on-dark text inside the Mini App. Our own index.css owns the theme.

// Telegram Mini Apps Analytics — required by @tapps_bot / Telegram Apps Center.
// Token comes from @tapps_bot (set at build time via VITE_TG_ANALYTICS_TOKEN).
const analyticsToken = import.meta.env.VITE_TG_ANALYTICS_TOKEN as string | undefined;
const analyticsAppName = (import.meta.env.VITE_TG_ANALYTICS_APP_NAME as string | undefined) ?? 'daily_horoscope';
if (analyticsToken) {
  try {
    telegramAnalytics.init({ token: analyticsToken, appName: analyticsAppName });
  } catch (err) {
    console.warn('[analytics] init failed:', err);
  }
}

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
